export default Object.freeze({
  registerAsMediator: {
    page: 'registerAsMediator',
    title: 'Постановка на учет в качестве медиатора',
    code: 3,
  },
  unregisterMediator: {
    page: 'unregisterMediator',
    title: 'Снятие с учета в качестве медиатора',
    code: 4,
  },
  registerAsInsuranceTaxPayer: {
    page: 'registerAsInsuranceTaxPayer',
    title: 'Постановка на учет в качестве плательщика страховых взносов',
    code: 1,
  },
  unregisterInsuranceTaxPayer: {
    page: 'unregisterInsuranceTaxPayer',
    title: 'Снятие с учета в качестве плательщика страховых взносов',
    code: 2,
  },
});
